import { render, staticRenderFns } from "./Reiting.vue?vue&type=template&id=621dc339&scoped=true&"
import script from "./Reiting.vue?vue&type=script&lang=js&"
export * from "./Reiting.vue?vue&type=script&lang=js&"
import style0 from "./Reiting.vue?vue&type=style&index=0&id=621dc339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621dc339",
  null
  
)

export default component.exports